export enum SortCriteria {
    BestMatch = 0,
    Price = 1,
}
